/**
 * Enhance extracted <table> with Table/Cards switch + pagination (9/page).
 * /md/ pages are handled separately by postProcessMdPage().
 *
 * IMPORTANT: All click handlers for /md/ pages use DOCUMENT-LEVEL EVENT
 * DELEGATION because multiple extract-element containers may exist for
 * the same URL, and only one will have directly-attached listeners.
 */

const CARDS_PER_PAGE = 9;
const DEBUG = false;
function log(...args) { if (DEBUG) console.log("[md-tools]", ...args); }

/* ===========================================================
   STYLES
   =========================================================== */
function injectMdStyles() {
	if (document.getElementById("md-page-styles")) return;
	const style = document.createElement("style");
	style.id = "md-page-styles";
	style.textContent = `
/* ── Breadcrumb ── */
.md-breadcrumb{display:flex;align-items:center;gap:.5rem;font-size:.875rem;margin-bottom:1rem;padding:.65rem .85rem;background:#f8fafc;border:1px solid #e8ecf0;border-radius:8px;font-family:system-ui,-apple-system,sans-serif;line-height:1.5}
.md-breadcrumb a.md-bc-back{display:inline-flex;align-items:center;gap:.3rem;color:#009cd6;text-decoration:none;cursor:pointer;font-weight:500;white-space:nowrap;padding:.15rem .5rem .15rem .25rem;border-radius:4px;transition:background .15s}
.md-breadcrumb a.md-bc-back:hover{background:#e5f5fb;text-decoration:none}
.md-breadcrumb a.md-bc-back svg{width:16px;height:16px;flex-shrink:0}
.md-breadcrumb .md-bc-sep{color:#c0c8d0;font-size:.8rem;margin:0 .1rem}
.md-breadcrumb .md-bc-doc-num{display:inline-block;background:#e5f5fb;color:#009cd6;font-weight:700;font-size:.8rem;padding:.1rem .45rem;border-radius:4px;white-space:nowrap}
.md-breadcrumb .md-bc-title{color:#444;font-size:.825rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:450px}
@media(max-width:768px){.md-breadcrumb .md-bc-title{max-width:180px}}

/* ── Header bar + controls ── */
.md-header-bar{display:flex;align-items:center;justify-content:space-between;padding:.6rem 0;margin-bottom:.75rem;font-family:system-ui,-apple-system,sans-serif}
.md-header-bar .md-result-count{font-size:.85rem;color:#666;margin:0}
.md-view-controls{display:inline-flex;overflow:hidden;gap:0}
.md-view-switch-btn{display:inline-flex;align-items:center;gap:.35rem;padding:.45rem .85rem;border:none;background:#fff;cursor:pointer;font-size:.825rem;color:#009cd6;font-weight:600;transition:all .15s ease;border-radius:6px}
.md-view-switch-btn:hover{background:#e5f5fb}
.md-view-switch-btn.is-active{color:#fff;background:#009cd6;border-radius:6px}
.md-view-switch-btn svg{fill:currentColor}

/* ── Table view ── */
.md-contributions-table{width:100%;border-collapse:collapse;font-family:system-ui,-apple-system,sans-serif;font-size:.9rem;border:1px solid #d0d7de;border-radius:8px;overflow:hidden}
.md-contributions-table thead th{background:#e5f5fb;color:#003b73;font-weight:600;padding:.6rem .75rem;text-align:left;border-bottom:2px solid #009cd6;font-size:.825rem;text-transform:uppercase;letter-spacing:.03em}
.md-contributions-table tbody td{padding:.6rem .75rem;border-bottom:1px solid #eaecef;vertical-align:top;color:#333}
.md-contributions-table tbody tr{cursor:pointer;transition:background .12s}
.md-contributions-table tbody tr:hover{background:#f0f8fc}
.md-contributions-table td.md-col-number{white-space:nowrap;font-weight:600;color:#009cd6}
.md-contributions-table td.md-col-title{line-height:1.45}
.md-contributions-table td.md-col-source{color:#009cd6}
.md-contributions-table td.md-col-date{white-space:nowrap;color:#555;font-size:.85rem}
.md-contributions-table .md-addendum{color:#c0392b;font-weight:600;font-size:.8rem;display:block;margin-top:.15rem}
.md-contributions-table td.md-col-checkbox{width:36px;text-align:center;padding-left:.5rem;padding-right:0}
.md-doc-checkbox{width:16px;height:16px;cursor:pointer;accent-color:#009cd6}

/* ── Cards view ── */
.md-contributions-cards{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:1rem;font-family:system-ui,-apple-system,sans-serif}
.md-contrib-card{background:#fff;border:1px solid #e2e6ea;border-top:3px solid #009cd6;border-radius:0 0 8px 8px;padding:0;display:flex;flex-direction:column;transition:box-shadow .25s ease,transform .25s ease;cursor:pointer;overflow:hidden}
.md-contrib-card:hover{box-shadow:0 0 1.5rem rgba(31,167,217,.21);transform:translateY(-2px)}
.md-contrib-card .md-card-header{padding:.75rem 1rem .5rem;border-bottom:1px solid #f0f2f5;display:flex;align-items:center;gap:.5rem}
.md-contrib-card .md-card-number{font-weight:700;color:#009cd6;font-size:.95rem;margin-bottom:.15rem}
.md-contrib-card .md-card-addendum{color:#c0392b;font-weight:600;font-size:.78rem}
.md-contrib-card .md-card-body{padding:.6rem 1rem;flex:1}
.md-contrib-card .md-card-field-label{font-size:.7rem;text-transform:uppercase;letter-spacing:.05em;color:#009cd6;font-weight:600;margin-bottom:.1rem;margin-top:.5rem}
.md-contrib-card .md-card-field-label:first-child{margin-top:0}
.md-contrib-card .md-card-field-value{font-size:.85rem;line-height:1.4;color:#1a1a1a}
.md-contrib-card .md-card-meta{display:flex;justify-content:space-between;align-items:center;font-size:.78rem;color:#666;padding:.5rem 1rem;background:#f8fafc;border-top:1px solid #f0f2f5}

/* ── Document detail: language rows ── */
.md-doc-cards{display:flex;flex-direction:column;gap:0;font-family:system-ui,-apple-system,sans-serif;border:1px solid #e2e6ea;border-radius:8px;overflow:hidden}
.md-doc-row{display:grid;grid-template-columns:120px 1fr auto;align-items:center;padding:.7rem 1rem;border-bottom:1px solid #eaecef;background:#fff}
.md-doc-row:last-child{border-bottom:none}
.md-doc-row:hover{background:#f0f8fc}
.md-doc-lang{font-weight:600;color:#003b73;font-size:.925rem}
.md-doc-links{display:flex;gap:1.5rem}
.md-doc-link{display:inline-flex;align-items:center;gap:.35rem;color:#009cd6;text-decoration:none;font-size:.9rem;font-weight:500}
.md-doc-link:hover{text-decoration:underline}
.md-doc-link svg{width:18px;height:18px;flex-shrink:0}
.md-doc-date{color:#555;font-size:.875rem;white-space:nowrap;text-align:right}

/* ── Document metadata ── */
.md-doc-meta{margin-top:1rem;margin-bottom:1rem;padding:.75rem 1rem;background:#fff;border:1px solid #e2e6ea;border-top:3px solid #009cd6;border-radius:0 0 8px 8px;font-family:system-ui,-apple-system,sans-serif;font-size:.875rem}
.md-meta-row{display:grid;grid-template-columns:100px 1fr;gap:.5rem;padding:.4rem 0;border-bottom:1px solid #f0f2f5}
.md-meta-row:last-child{border-bottom:none}
.md-meta-label{font-size:.7rem;text-transform:uppercase;letter-spacing:.05em;color:#009cd6;font-weight:600;padding-top:.15rem}
.md-meta-value{color:#333;line-height:1.45}
.md-meta-value a{color:#0083b3}

/* ── Loading ── */
.md-loading{display:flex;align-items:center;gap:.5rem;padding:1.5rem;color:#666;font-size:.9rem;font-family:system-ui,sans-serif}
.md-loading::before{content:"";width:18px;height:18px;border:2px solid #d0d7de;border-top-color:#009cd6;border-radius:50%;animation:md-spin .6s linear infinite}
@keyframes md-spin{to{transform:rotate(360deg)}}

/* ── Preserved sections (download tools, preferences) ── */
.md-preserved-sections{margin-top:1.25rem;padding:1rem;background:#fff;border:1px solid #e2e6ea;border-radius:8px;font-family:system-ui,-apple-system,sans-serif;font-size:.85rem}

/* ── TIES inline login ── */

.md-preserved-sections b,.md-preserved-sections strong{color:#003b73}
.md-preserved-sections table{border-collapse:collapse;font-size:.85rem;margin-top:.5rem}
.md-preserved-sections td,.md-preserved-sections th{padding:.35rem .5rem !important;border:1px solid #e2e6ea !important}
/* Override ALL bgcolor yellow cells → #e5f5fb */
.md-preserved-sections [bgcolor]{ background-color:#e5f5fb !important}
.md-preserved-sections th,.md-preserved-sections td[bgcolor]{ background:#e5f5fb !important}
.md-preserved-sections input[type="checkbox"]{margin-right:.3rem;accent-color:#009cd6}
/* Force ituBtn style on ALL buttons/inputs — class added via JS, inline styles stripped */
.md-preserved-sections .ituBtn{box-sizing:border-box}



/* ── Zip dialog modal ── */
#md-zip-overlay{position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.45);display:flex;justify-content:center;align-items:center;z-index:2147483647;animation:md-ov-in .2s ease;isolation:isolate}
@keyframes md-ov-in{from{opacity:0}to{opacity:1}}
.md-zip-modal{background:#fff;border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,.18);width:92%;max-width:420px;overflow:hidden;animation:md-modal-in .25s ease;font-family:system-ui,-apple-system,sans-serif}
@keyframes md-modal-in{from{opacity:0;transform:scale(.95) translateY(8px)}to{opacity:1;transform:scale(1) translateY(0)}}
.md-zip-modal-header{display:flex;align-items:center;gap:.5rem;padding:.75rem 1.25rem;border-bottom:1px solid #eee;color:#555;font-size:.85rem}
.md-zip-modal-body{padding:1.25rem 1.5rem;min-height:80px}
.md-zip-modal-count{font-size:1rem;font-weight:700;color:#1a1a1a;margin-bottom:.5rem}
.md-zip-modal-msg{font-size:.9rem;color:#555;line-height:1.5}
.md-zip-modal-footer{display:flex;justify-content:flex-end;gap:.5rem;padding:.75rem 1.25rem;border-top:1px solid #eee}
.md-zip-modal-cancel{padding:.45rem 1.1rem;border:1px solid #d0d0d0;border-radius:6px;background:#fff;color:#555;font-size:.875rem;font-weight:500;cursor:pointer}
.md-zip-modal-cancel:hover{background:#f5f5f5}
.md-zip-modal-ok{padding:.45rem 1.3rem;border:none;border-radius:6px;background:#009cd6;color:#fff;font-size:.875rem;font-weight:600;cursor:pointer;min-width:64px}
.md-zip-modal-ok:hover{background:#0083b3}
.md-zip-modal-ok:focus{outline:2px solid #009cd6;outline-offset:2px}
/* Loading state */
.md-zip-loading{display:flex;flex-direction:column;align-items:center;gap:.75rem;padding:.5rem 0}
.md-zip-spinner{width:36px;height:36px;border:3px solid #e5f5fb;border-top-color:#009cd6;border-radius:50%;animation:md-zspin .7s linear infinite}
@keyframes md-zspin{to{transform:rotate(360deg)}}
.md-zip-loading .md-zip-modal-count{text-align:center}
.md-zip-loading .md-zip-modal-msg{text-align:center;font-size:.85rem}
/* Done state */
.md-zip-done{display:flex;flex-direction:column;align-items:center;gap:.5rem;padding:.5rem 0}
.md-zip-done svg{flex-shrink:0}
.md-zip-done .md-zip-modal-count{text-align:center}
.md-zip-done .md-zip-modal-msg{text-align:center;font-size:.85rem;color:#888}
/* Login state */
.md-zip-login-msg{text-align:center;font-size:.9rem;color:#e67e22;margin-bottom:.25rem}
.md-zip-login-hint{text-align:center;font-size:.85rem;color:#888}


/* ── TIES login inside modal ── */
.md-ties-card{background:#fff;border-radius:12px;border:1px solid #e0e7ec;padding:2rem 1.75rem 1.5rem;text-align:left;max-width:380px;margin:0 auto}
.md-ties-logo{margin-bottom:1rem}
.md-ties-logo svg{width:56px;height:56px}
.md-ties-title{font-size:1.35rem;font-weight:700;color:#1a1a1a;margin-bottom:1.5rem}
.md-ties-error{background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:.6rem .85rem;margin-bottom:1rem;font-size:.825rem;color:#b91c1c;line-height:1.4}
.md-ties-field{margin-bottom:.85rem}
.md-ties-field input{width:100%;box-sizing:border-box;padding:.7rem .85rem;border:1.5px solid #d0d7de;border-radius:6px;font-size:.9rem;font-family:inherit;outline:none;transition:border-color .2s,box-shadow .2s;background:#fff}
.md-ties-field input::placeholder{color:#999}
.md-ties-field input:focus{border-color:#00b7e6;box-shadow:0 0 0 3px rgba(0,183,230,.12)}
.md-ties-show-pwd{display:flex;align-items:center;gap:.45rem;margin-bottom:1.25rem;font-size:.85rem;color:#444;cursor:pointer;user-select:none}
.md-ties-show-pwd input[type=checkbox]{accent-color:#00b7e6;width:16px;height:16px;cursor:pointer}
.md-ties-submit{width:100%;padding:.7rem;border:none;border-radius:8px;background:#00b7e6;color:#fff;font-size:.95rem;font-weight:600;cursor:pointer;font-family:inherit;transition:background .2s;letter-spacing:.01em}
.md-ties-submit:hover{background:#009fd4}
.md-ties-submit:active{background:#008dba}
.md-ties-submit:focus{outline:2px solid #00b7e6;outline-offset:2px}
.md-ties-links{margin-top:1.25rem;font-size:.825rem;line-height:1.7;color:#444}
.md-ties-links a{color:#00b7e6;text-decoration:none;font-weight:500}
.md-ties-links a:hover{text-decoration:underline}

/* ── Responsive ── */
@media(max-width:768px){
  .md-doc-row{grid-template-columns:1fr;gap:.35rem;padding:.6rem .75rem}
  .md-doc-date{text-align:left}
  .md-contributions-cards{grid-template-columns:1fr}
  .md-header-bar{flex-direction:column;gap:.5rem;align-items:flex-start}
  .md-meta-row{grid-template-columns:1fr;gap:.15rem}
  /* Force cards only on mobile — hide switch + table */
  .md-view-controls{display:none !important}
  .md-contributions-table{display:none !important}
  .md-contributions-cards{display:grid !important}
  /* Save Preferences: break row so button wraps below */
  .md-preserved-sections td[rowspan]{display:block;width:100%;padding-top:.5rem !important}
  .md-preserved-sections table{width:100%}
  .md-preserved-sections tr{display:flex;flex-wrap:wrap}
  .md-preserved-sections td,.md-preserved-sections th{flex:1 1 auto;min-width:0}
}

/* ── Hub Article Cards ── */
.hub-cards-wrapper{font-family:system-ui,-apple-system,sans-serif}
.hub-cards-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:1rem}
.hub-cards-count{font-size:.85rem;color:#666}
.hub-cards-count strong{color:#003764}
.hub-cards-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.25rem}
@media(max-width:960px){.hub-cards-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:560px){.hub-cards-grid{grid-template-columns:1fr}}
.hub-card{background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 1px 4px rgba(0,0,0,.07);transition:box-shadow .2s,transform .2s;cursor:pointer;display:flex;flex-direction:column;text-decoration:none;color:inherit;border:1px solid #e8ecf0}
.hub-card:hover{box-shadow:0 6px 20px rgba(0,0,0,.12);transform:translateY(-3px)}
.hub-card-img{width:100%;aspect-ratio:16/10;object-fit:cover;display:block;background:#d8e8f0}
.hub-card-img-placeholder{width:100%;aspect-ratio:16/10;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#d8e8f0 0%,#e5f5fb 100%);color:#009cd6;font-size:2rem}
.hub-card-body{padding:14px 16px 18px;flex:1;display:flex;flex-direction:column}
.hub-card-tag{font-size:.75rem;font-weight:600;color:#009cd6;text-transform:uppercase;letter-spacing:.04em;margin-bottom:6px}
.hub-card-title{font-size:.95rem;font-weight:700;line-height:1.35;color:#1a1a1a;margin:0 0 auto;flex:1}
.hub-card:hover .hub-card-title{color:#009cd6}
.hub-card-date{font-size:.8rem;color:#888;margin-top:10px}
.hub-cards-pagination{display:flex;justify-content:center;align-items:center;gap:6px;margin-top:1.5rem}
.hub-cards-pagination .page-numbers{display:inline-flex;align-items:center;justify-content:center;min-width:36px;height:36px;padding:0 8px;border-radius:50%;font-size:.9rem;font-weight:500;color:#009cd6;background:#fff;border:1px solid #e2e6ea;cursor:pointer;text-decoration:none;transition:all .15s}
.hub-cards-pagination .page-numbers:hover{background:#e5f5fb;border-color:#009cd6}
.hub-cards-pagination .page-numbers.current,.hub-cards-pagination span.page-numbers:not(.dots){background:#009cd6;color:#fff;border-color:#009cd6;cursor:default}
.hub-cards-pagination .page-numbers.next,.hub-cards-pagination .page-numbers.prev{font-size:.8rem;border-radius:18px;padding:0 12px}
`;
	document.head.appendChild(style);
}

/* ===========================================================
   Zip download: all-in-modal with hidden iframe
   No popup, no new tab — iframe is same-domain so cookies work.
   =========================================================== */

/* Shared iframe name — reuse across attempts so cookies persist */
var ZIP_IFRAME_NAME = "itu_zip_frame";

function getOrCreateIframe() {
	var iframe = document.getElementById(ZIP_IFRAME_NAME);
	if (iframe) return iframe;
	iframe = document.createElement("iframe");
	iframe.id = ZIP_IFRAME_NAME;
	iframe.name = ZIP_IFRAME_NAME;
	iframe.style.cssText = "position:fixed;width:0;height:0;border:0;opacity:0;pointer-events:none;top:-9999px;left:-9999px;";
	document.body.appendChild(iframe);
	return iframe;
}

/**
 * Submit a form INTO the iframe.
 * Strategy: try to build the form INSIDE the iframe document (same-origin = cookies sent).
 * Fallback: build from parent with form.target (for cross-origin or blank iframe).
 */
function submitToIframe(action, fields) {
	var iframe = getOrCreateIframe();

	/* Try submitting from inside the iframe (ensures cookies from TIES auth are sent) */
	try {
		var iDoc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
		if (iDoc && iDoc.body) {
			var form = iDoc.createElement("form");
			form.method = "POST";
			form.action = action;
			form.style.display = "none";
			fields.forEach(function(f) {
				var inp = iDoc.createElement("input");
				inp.type = "hidden";
				inp.name = f.name;
				inp.value = f.value;
				form.appendChild(inp);
			});
			iDoc.body.appendChild(form);
			form.submit();
			return;
		}
	} catch(e) { /* cross-origin or blank — use fallback */ }

	/* Fallback: submit from parent, targeting iframe */
	var form = document.createElement("form");
	form.method = "POST";
	form.action = action;
	form.target = ZIP_IFRAME_NAME;
	form.style.display = "none";
	fields.forEach(function(f) {
		var inp = document.createElement("input");
		inp.type = "hidden";
		inp.name = f.name;
		inp.value = f.value;
		form.appendChild(inp);
	});
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
}

/* Main entry point */
function showZipDialog(ids, formAction) {
	var old = document.getElementById("md-zip-overlay");
	if (old) old.remove();

	var ov = document.createElement("div");
	ov.id = "md-zip-overlay";

	var modal = document.createElement("div");
	modal.className = "md-zip-modal";

	var header = document.createElement("div");
	header.className = "md-zip-modal-header";
	header.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#009cd6" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg><span>www.itu.int</span>';

	var body = document.createElement("div");
	body.className = "md-zip-modal-body";
	body.innerHTML = '<div class="md-zip-modal-count">' + ids.length + ' document' + (ids.length > 1 ? 's' : '') + ' selected</div><div class="md-zip-modal-msg">Please click OK and wait for the Zip file to be created...</div>';

	var footer = document.createElement("div");
	footer.className = "md-zip-modal-footer";

	var cancelBtn = document.createElement("button");
	cancelBtn.type = "button";
	cancelBtn.className = "md-zip-modal-cancel";
	cancelBtn.textContent = "Cancel";
	cancelBtn.addEventListener("click", function() { ov.remove(); });

	var okBtn = document.createElement("button");
	okBtn.type = "button";
	okBtn.className = "md-zip-modal-ok";
	okBtn.textContent = "OK";

	footer.appendChild(cancelBtn);
	footer.appendChild(okBtn);
	modal.appendChild(header);
	modal.appendChild(body);
	modal.appendChild(footer);
	ov.appendChild(modal);
	document.body.appendChild(ov);

	ov.addEventListener("click", function(ev) { if (ev.target === ov) ov.remove(); });
	function onEsc(ev) { if (ev.key === "Escape") { ov.remove(); document.removeEventListener("keydown", onEsc); } }
	document.addEventListener("keydown", onEsc);
	setTimeout(function() { okBtn.focus(); }, 50);

	okBtn.addEventListener("click", function() {
		body.innerHTML = '<div class="md-zip-loading"><div class="md-zip-spinner"></div><div class="md-zip-modal-count">Zip file in preparation</div><div class="md-zip-modal-msg">Please wait, this may take a moment...</div></div>';
		footer.innerHTML = '';

		var iframe = getOrCreateIframe();
		var fields = ids.map(function(id) { return { name: "chkFile", value: id }; });
		submitToIframe(formAction, fields);

		/* Poll iframe to detect TIES login or download */
		var polls = 0;
		var timer = setInterval(function() {
			polls++;

			if (polls >= 20) {
				clearInterval(timer);
				showZipDone(body, footer, ov);
				return;
			}

			try {
				var iDoc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
				if (!iDoc || !iDoc.body || iDoc.body.innerHTML.length < 50) return;

				var hasTies = iDoc.querySelector('form[name="Ties"]') || iDoc.querySelector('input[name="login"]');
				if (hasTies) {
					clearInterval(timer);

					var tiesForm = iDoc.querySelector('form[name="Ties"]');
					var loginVal = (iDoc.querySelector('input[name="login"]') || {}).value || "";
					var tiesAction = "";
					if (tiesForm) tiesAction = tiesForm.action || tiesForm.getAttribute("action") || "";
					if (tiesAction && !tiesAction.startsWith("http")) {
						try { tiesAction = new URL(tiesAction, "https://www.itu.int").href; } catch(e) {}
					}
					var hiddenInputs = [];
					if (tiesForm) tiesForm.querySelectorAll('input[type="hidden"]').forEach(function(h) {
						hiddenInputs.push({ name: h.name, value: h.value });
					});
					var errorMsg = "";
					var fontRed = iDoc.querySelector('font[color="red"], font[color="Red"]');
					if (fontRed) errorMsg = fontRed.textContent.trim();

					showTiesLoginInModal(body, footer, ov, tiesAction, hiddenInputs, loginVal, errorMsg, ids, formAction);
					return;
				}

				/* No TIES = download started */
				clearInterval(timer);
				showZipDone(body, footer, ov);
			} catch(e) {
				clearInterval(timer);
				showZipDone(body, footer, ov);
			}
		}, 500);
	});
}

/* TIES login form inside our modal */
function showTiesLoginInModal(body, footer, ov, tiesAction, hiddenInputs, loginVal, errorMsg, ids, formAction) {
	var ituLogo = '<img src="https://www.itu.int/br-staging/wp-content/themes/WordPressTemplate%20Septembre%202025%20v2.2/assets/images/ITU_logo_color.svg" alt="ITU" style="height:56px;width:auto;">';

	var html = '<div class="md-ties-card">';
	html += '<div class="md-ties-logo">' + ituLogo + '</div>';
	html += '<div class="md-ties-title">Log in</div>';

	if (errorMsg) {
		html += '<div class="md-ties-error">' + errorMsg.replace(/</g, '&lt;') + '</div>';
	}

	html += '<div class="md-ties-field"><input type="text" id="md-ties-login" placeholder="E-mail / Username" autocomplete="username" value="' + (loginVal || '').replace(/"/g, '&quot;') + '"></div>';
	html += '<div class="md-ties-field"><input type="password" id="md-ties-pwd" placeholder="Password" autocomplete="current-password"></div>';
	html += '<label class="md-ties-show-pwd"><input type="checkbox" id="md-ties-toggle-pwd"> Show Password</label>';
	html += '<button type="button" class="md-ties-submit" id="md-ties-submit-btn">Log in</button>';
	html += '<div class="md-ties-links">';
	html += '<a href="https://www.itu.int/en/ties-services/Pages/forgotpwd.aspx" target="_blank">Forgot my password?</a><br>';
	html += 'No ITU User Account yet? <a href="https://www.itu.int/en/ties-services/Pages/createaccount.aspx" target="_blank">Click here</a> to create one.<br>';
	html += 'Need some help? <a href="https://www.itu.int/en/service-desk" target="_blank">Contact Service Desk</a>.';
	html += '</div>';
	html += '</div>';

	body.innerHTML = html;
	body.style.padding = "1rem 1rem 0";
	var modalHeader = ov.querySelector(".md-zip-modal-header");
	if (modalHeader) modalHeader.style.display = "none";
	ov.querySelector(".md-zip-modal").style.background = "#f4fafb";
	footer.innerHTML = '<button type="button" class="md-zip-modal-cancel" id="md-ties-cancel">Cancel</button>';

	document.getElementById("md-ties-toggle-pwd").addEventListener("change", function() {
		document.getElementById("md-ties-pwd").type = this.checked ? "text" : "password";
	});

	document.getElementById("md-ties-cancel").addEventListener("click", function() { ov.remove(); });

	var loginInput = document.getElementById("md-ties-login");
	var pwdInput = document.getElementById("md-ties-pwd");
	if (loginInput && loginInput.value) {
		setTimeout(function() { pwdInput.focus(); }, 80);
	} else {
		setTimeout(function() { loginInput.focus(); }, 80);
	}

	function onEnter(ev) { if (ev.key === "Enter") doSubmit(); }
	loginInput.addEventListener("keydown", onEnter);
	pwdInput.addEventListener("keydown", onEnter);
	document.getElementById("md-ties-submit-btn").addEventListener("click", doSubmit);

	function doSubmit() {
		var login = document.getElementById("md-ties-login").value.trim();
		var pwd = document.getElementById("md-ties-pwd").value;
		if (!login || !pwd) return;

		body.innerHTML = '<div class="md-zip-loading"><div class="md-zip-spinner"></div><div class="md-zip-modal-count">Signing in...</div><div class="md-zip-modal-msg">Please wait</div></div>';
		body.style.padding = "";
		var mh = ov.querySelector(".md-zip-modal-header");
		if (mh) mh.style.display = "";
		ov.querySelector(".md-zip-modal").style.background = "";
		footer.innerHTML = '';

		/* Submit TIES login to the SAME hidden iframe */
		var loginFields = hiddenInputs.slice();
		loginFields.push({ name: "login", value: login });
		loginFields.push({ name: "Password", value: pwd });
		submitToIframe(tiesAction || "https://www.itu.int/ties/tbauth.asp", loginFields);

		/*
		 * After login, TIES redirects through several pages setting cookies.
		 * Wait 5 seconds, then re-submit the zip request.
		 * The key: submit from INSIDE the iframe so TIES cookies are sent.
		 */
		var polls2 = 0;
		var timer2 = setInterval(function() {
			polls2++;

			/* Skip first 10 polls (5s) — let TIES redirect chain fully complete */
			if (polls2 <= 10) return;

			if (polls2 >= 30) {
				clearInterval(timer2);
				/* Timeout — try submitting zip anyway */
				resubmitZip(body, footer, ov, ids, formAction);
				return;
			}

			try {
				var iframe = document.getElementById(ZIP_IFRAME_NAME);
				if (!iframe) { clearInterval(timer2); return; }
				var iDoc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
				if (!iDoc || !iDoc.body || iDoc.body.innerHTML.length < 50) return;

				/* Still on login page WITH red error text = wrong credentials */
				var stillLogin = iDoc.querySelector('form[name="Ties"]') || iDoc.querySelector('input[name="login"]');
				var hasError = iDoc.querySelector('font[color="red"], font[color="Red"], .error');

				if (stillLogin && hasError) {
					clearInterval(timer2);
					var newErr = hasError.textContent.trim() || "Login failed. Please check your credentials.";
					showTiesLoginInModal(body, footer, ov, tiesAction, hiddenInputs, login, newErr, ids, formAction);
					return;
				}

				/* Login form still showing without error = redirect in progress, keep waiting */
				if (stillLogin) return;

				/* No login form = auth succeeded → re-submit zip */
				clearInterval(timer2);
				resubmitZip(body, footer, ov, ids, formAction);
			} catch(e) {
				/* Cross-origin = navigated successfully = auth succeeded */
				clearInterval(timer2);
				resubmitZip(body, footer, ov, ids, formAction);
			}
		}, 500);
	}
}

/* Re-submit zip after TIES login — submits from inside iframe to carry cookies */
function resubmitZip(body, footer, ov, ids, formAction) {
	body.innerHTML = '<div class="md-zip-loading"><div class="md-zip-spinner"></div><div class="md-zip-modal-count">Zip file in preparation</div><div class="md-zip-modal-msg">Downloading documents...</div></div>';
	footer.innerHTML = '';

	var fields = ids.map(function(id) { return { name: "chkFile", value: id }; });
	submitToIframe(formAction, fields);

	/* Poll iframe — if TIES appears again, cookies didn't stick, ask login again */
	var polls3 = 0;
	var timer3 = setInterval(function() {
		polls3++;

		if (polls3 >= 16) {
			clearInterval(timer3);
			showZipDone(body, footer, ov);
			return;
		}

		/* Skip first 4 polls (2s) */
		if (polls3 <= 4) return;

		try {
			var iframe = document.getElementById(ZIP_IFRAME_NAME);
			if (!iframe) { clearInterval(timer3); return; }
			var iDoc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
			if (!iDoc || !iDoc.body || iDoc.body.innerHTML.length < 50) return;

			/* If TIES appears again after re-submit, show login again */
			var hasTies = iDoc.querySelector('form[name="Ties"]') || iDoc.querySelector('input[name="login"]');
			if (hasTies) {
				clearInterval(timer3);
				var tiesForm = iDoc.querySelector('form[name="Ties"]');
				var tiesAction = "";
				if (tiesForm) tiesAction = tiesForm.action || tiesForm.getAttribute("action") || "";
				if (tiesAction && !tiesAction.startsWith("http")) {
					try { tiesAction = new URL(tiesAction, "https://www.itu.int").href; } catch(e) {}
				}
				var hiddenInputs = [];
				if (tiesForm) tiesForm.querySelectorAll('input[type="hidden"]').forEach(function(h) {
					hiddenInputs.push({ name: h.name, value: h.value });
				});
				var loginVal = (iDoc.querySelector('input[name="login"]') || {}).value || "";
				showTiesLoginInModal(body, footer, ov, tiesAction, hiddenInputs, loginVal, "Session expired — please log in again.", ids, formAction);
				return;
			}

			/* No TIES = download started */
			clearInterval(timer3);
			showZipDone(body, footer, ov);
		} catch(e) {
			clearInterval(timer3);
			showZipDone(body, footer, ov);
		}
	}, 500);
}

/* Success state */
function showZipDone(body, footer, ov) {
	body.innerHTML = '<div class="md-zip-done"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#27ae60" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><div class="md-zip-modal-count">Download initiated</div><div class="md-zip-modal-msg">Check your downloads folder</div></div>';
	body.style.padding = "";
	var mh = ov.querySelector(".md-zip-modal-header");
	if (mh) mh.style.display = "";
	ov.querySelector(".md-zip-modal").style.background = "";
	footer.innerHTML = '<button type="button" class="md-zip-modal-ok" onclick="this.closest(\'#md-zip-overlay\').remove()">Close</button>';
	setTimeout(function() { if (ov.parentNode) ov.remove(); }, 5000);
}

/* ===========================================================
   DOCUMENT-LEVEL EVENT DELEGATION
   =========================================================== */
let _delegationInstalled = false;

function installDelegation() {
	if (_delegationInstalled) return;
	_delegationInstalled = true;

	document.addEventListener("click", function (e) {
		/* ── Guard: ignore clicks outside any extract container
		      so Bootstrap modal backdrop clicks are never intercepted ── */
		const withinExtract = e.target.closest(
			".extracted-content-placeholder, #extracted-content-placeholder, .md-contributions-wrapper, #md-zip-overlay"
		);
		if (!withinExtract) return;

		/* ── Checkbox — stop propagation so row/card click doesn't navigate ── */
		if (e.target.classList && e.target.classList.contains("md-doc-checkbox")) {
			e.stopPropagation();
			/* Sync checkbox state between table and cards (same cbValue) */
			const val = e.target.value;
			const checked = e.target.checked;
			document.querySelectorAll(`.md-doc-checkbox[value="${CSS.escape(val)}"]`).forEach((cb) => {
				cb.checked = checked;
			});
			return;
		}

		/* ── Table/Cards switch button ── */
		const switchBtn = e.target.closest(".md-view-switch-btn");
		if (switchBtn) {
			e.stopPropagation();
			const wrapper = switchBtn.closest(".md-contributions-wrapper");
			if (!wrapper) return;

			const isTable = switchBtn.textContent.includes("Table");
			const tableEl = wrapper.querySelector(".md-contributions-table");
			const cardsEl = wrapper.querySelector(".md-contributions-cards");
			if (!tableEl || !cardsEl) return;

			if (isTable) {
				tableEl.style.display = "";
				cardsEl.style.display = "none";
			} else {
				tableEl.style.display = "none";
				cardsEl.style.display = "grid";
			}

			wrapper.querySelectorAll(".md-view-switch-btn").forEach(b => b.classList.remove("is-active"));
			switchBtn.classList.add("is-active");
			log("Switch to:", isTable ? "table" : "cards");
			return;
		}

		/* ── Click on table row ── */
		const row = e.target.closest(".md-contributions-table tbody tr");
		if (row) {
			const docUrl = row.dataset.docUrl;
			const docLabel = row.dataset.docLabel;
			if (!docUrl) return;

			const container = row.closest(".extracted-content-placeholder, #extracted-content-placeholder");
			if (!container) return;

			const listUrl = container.getAttribute("data-url") || "";
			log("ROW CLICK:", docLabel, docUrl);
			navigateToDocument(container, listUrl, docUrl, docLabel);
			return;
		}

		/* ── Click on card ── */
		const card = e.target.closest(".md-contrib-card");
		if (card) {
			const docUrl = card.dataset.docUrl;
			const docLabel = card.dataset.docLabel;
			if (!docUrl) return;

			const container = card.closest(".extracted-content-placeholder, #extracted-content-placeholder");
			if (!container) return;

			const listUrl = container.getAttribute("data-url") || "";
			log("CARD CLICK:", docLabel, docUrl);
			navigateToDocument(container, listUrl, docUrl, docLabel);
			return;
		}

		/* ── Breadcrumb back link ── */
		const bcLink = e.target.closest(".md-bc-back");
		if (bcLink) {
			e.preventDefault();
			const container = bcLink.closest(".extracted-content-placeholder, #extracted-content-placeholder");
			if (!container) return;

			const listUrl = container.getAttribute("data-url") || "";
			log("BACK CLICK:", listUrl);
			reloadList(container, listUrl);
			return;
		}

		/* ── Click outside modal → close ── */
		if (e.target.classList && e.target.classList.contains("modal-overlay")) {
			e.target.classList.remove("is-visible");
			return;
		}

		/* ── Check all / Uncheck all / Zip buttons (delegated for modal support) ── */
		const actionBtn = e.target.closest(".md-action-check-all, .md-action-uncheck-all, .md-action-zip");
		if (actionBtn) {
			e.preventDefault();
			e.stopPropagation();
			const wrapper = actionBtn.closest(".md-contributions-wrapper");
			if (!wrapper) return;

			if (actionBtn.classList.contains("md-action-check-all")) {
				wrapper.querySelectorAll(".md-doc-checkbox").forEach((cb) => { cb.checked = true; });
				log("Check all");
			} else if (actionBtn.classList.contains("md-action-uncheck-all")) {
				wrapper.querySelectorAll(".md-doc-checkbox").forEach((cb) => { cb.checked = false; });
				log("Uncheck all");
			} else if (actionBtn.classList.contains("md-action-zip")) {
				const checked = Array.from(wrapper.querySelectorAll(".md-doc-checkbox:checked"));
				if (!checked.length) { alert("Please select at least one document."); return; }
				const ids = checked.map((cb) => (cb.value || "").trim()).filter(Boolean);
				log("Zip download, ids:", ids);

				const container = wrapper.closest(".extracted-content-placeholder, #extracted-content-placeholder");
				const listUrl = container?.getAttribute("data-url") || "";
				const parentId = listUrl.match(/\/md\/([^/]+)/)?.[1] || "";
				const formAction = "https://www.itu.int/md/md_zipfiles.asp?lang=en&parent=" + encodeURIComponent(parentId);

				showZipDialog(ids, formAction);
			}
			return;
		}
	});
}

/* ===========================================================
   Helpers
   =========================================================== */
function findContributionsTable(container) {
	let t = container.querySelector('table[bgcolor="#004080"]');
	if (t) return t;
	const tables = container.querySelectorAll("table[bgcolor]");
	for (const tbl of tables) {
		const bg = (tbl.getAttribute("bgcolor") || "").replace(/\s/g, "").toLowerCase();
		if (bg.includes("004080")) return tbl;
	}
	return null;
}

function findHeaderRow(table) {
	return table.querySelector('tr[bgcolor="#FFFFC4"]') ||
		table.querySelector('tr[bgcolor="#ffffc4"]') ||
		null;
}

/* ===========================================================
   postProcessMdPage
   =========================================================== */
export function postProcessMdPage(container) {
	if (!container) return;
	const sourceUrl = (container.getAttribute("data-url") || "");
	if (!sourceUrl.includes("itu.int/md/")) return;

	if (container.querySelector(".md-contributions-wrapper") ||
		container.querySelector(".md-doc-cards") ||
		container.querySelector(".md-loading")) {
		log("SKIP — UI already built in this container");
		return;
	}

	log("postProcessMdPage called, url:", sourceUrl);
	injectMdStyles();
	installDelegation();

	const contribTable = findContributionsTable(container);
	const hasDocFormats = !!container.querySelector('a[href*="PDF-"], a[href*="MSW-"], a[href*="pdf-"], a[href*="msw-"]');

	log("contribTable found:", !!contribTable, "hasDocFormats:", hasDocFormats);

	if (contribTable) {
		buildContributionsView(container, contribTable, sourceUrl);
	} else if (hasDocFormats) {
		renderDocumentCards(container, null, null);
	}
}

/* ===========================================================
   Type 1: list
   =========================================================== */
function buildContributionsView(container, srcTable, listUrl) {
	const headerTr = findHeaderRow(srcTable);
	if (!headerTr) { log("No header row found"); return; }

	const allRows = Array.from(srcTable.querySelectorAll("tr"));
	const dataRows = allRows.filter((tr) => {
		if (tr === headerTr) return false;
		const bg = (tr.getAttribute("bgcolor") || "").toUpperCase();
		if (bg === "#B9C6FF") return false;
		const tds = tr.querySelectorAll("td");
		if (tds.length < 5) return false;
		return !!tr.querySelector('input[type="checkbox"]') || !!tr.querySelector('a[href*="meetingdoc"]');
	});

	log("dataRows found:", dataRows.length);
	if (!dataRows.length) return;

	const countMatch = srcTable.textContent.match(/Results:\s*(\d+)\s*total/i);
	const resultCount = countMatch ? countMatch[1] : dataRows.length;

	/* Parse rows */
	const items = [];
	dataRows.forEach((srcRow) => {
		const cells = Array.from(srcRow.querySelectorAll("td"));
		if (cells.length < 5) return;

		const checkboxCell = cells[0];
		const numberCell = cells[1];
		const titleCell = cells[2];
		const sourceCell = cells[3];
		const dateCell = cells[4];
		if (!numberCell || !titleCell) return;

		const numLink = numberCell.querySelector("a");
		const addendum = numberCell.querySelector('font[color="red"]');
		const srcLink = sourceCell?.querySelector("a");
		const checkbox = checkboxCell?.querySelector('input[type="checkbox"]');

		let docId = "";
		if (checkbox) {
			const cbVal = checkbox.getAttribute("value") || "";
			docId = cbVal.split(/\s*\\\\/)[0].trim();
		}

		let docUrl = "";
		if (docId) {
			docUrl = `https://www.itu.int/md/${docId}/en`;
		} else if (numLink) {
			docUrl = numLink.getAttribute("href") || "";
		}

		let numText = "";
		if (numLink) {
			numText = numLink.textContent.trim();
		} else {
			const raw = numberCell.textContent.replace(/[\u00a0\s]+/g, " ").trim();
			const bracketMatch = raw.match(/\[\s*\d+\s*\]/);
			if (bracketMatch) numText = bracketMatch[0];
			else {
				const numMatch = raw.match(/\d+/);
				numText = numMatch ? numMatch[0] : raw;
			}
		}

		items.push({
			numText,
			docUrl,
			addendum: addendum ? addendum.textContent.trim() : "",
			title: titleCell.textContent.replace(/\s+/g, " ").trim(),
			sourceText: srcLink ? srcLink.textContent.trim() : (sourceCell ? sourceCell.textContent.replace(/\s+/g, " ").trim() : ""),
			date: dateCell ? dateCell.textContent.trim() : "",
			cbValue: checkbox ? (checkbox.getAttribute("value") || "") : "",
			cbName: checkbox ? (checkbox.getAttribute("name") || "") : "",
			cbChecked: checkbox ? checkbox.checked : false,
		});
	});

	if (!items.length) return;

	/* ═══ Preserve sections after the table (download tools, preferences) ═══ */
	let preservedSections = null;
	let node = srcTable.nextSibling;
	if (node) {
		preservedSections = document.createElement("div");
		preservedSections.className = "md-preserved-sections";
		while (node) {
			preservedSections.appendChild(node.cloneNode(true));
			node = node.nextSibling;
		}
	}

	/* ═══ Build DOM ═══ */
	container.innerHTML = "";

	const wrapper = document.createElement("div");
	wrapper.className = "md-contributions-wrapper";

	/* Header bar: count + view toggle */
	const isMobile = window.innerWidth <= 768;
	const currentView = isMobile ? "cards" : "table";

	const headerBar = document.createElement("div");
	headerBar.className = "md-header-bar";
	headerBar.innerHTML = `
		<div class="md-result-count">${resultCount} document${Number(resultCount) > 1 ? "s" : ""}</div>
		<div class="md-view-controls">
			<button type="button" class="md-view-switch-btn${currentView === "table" ? " is-active" : ""}">
				<svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor"><path d="M18 3H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM2 8h5v4H2V8zm7 0h9v4H9V8zM2 5h16v1H2V5zm0 9h5v1H2v-1zm7 0h9v1H9v-1z"/></svg> Table
			</button>
			<button type="button" class="md-view-switch-btn${currentView === "cards" ? " is-active" : ""}">
				<svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor"><path d="M2 2h4v4H2V2zm6 0h4v4H8V2zm6 0h4v4h-4V2zM2 8h4v4H2V8zm6 0h4v4H8V8zm6 0h4v4h-4V8zM2 14h4v4H2v-4zm6 0h4v4H8v-4zm6 0h4v4h-4v-4z"/></svg> Cards
			</button>
		</div>`;
	wrapper.appendChild(headerBar);

	/* TABLE */
	const tableEl = document.createElement("table");
	tableEl.className = "md-contributions-table";
	tableEl.innerHTML = `<thead><tr><th style="width:36px"></th><th>Number</th><th>Title</th><th>Source</th><th>Date</th></tr></thead>`;
	const tbody = document.createElement("tbody");

	items.forEach((item) => {
		const tr = document.createElement("tr");
		tr.dataset.docUrl = item.docUrl;
		tr.dataset.docLabel = item.numText + " — " + item.title;

		/* Checkbox cell */
		const tdCb = document.createElement("td");
		tdCb.className = "md-col-checkbox";
		if (item.cbValue) {
			const cb = document.createElement("input");
			cb.type = "checkbox";
			cb.className = "md-doc-checkbox";
			cb.value = item.cbValue;
			if (item.cbName) cb.name = item.cbName;
			cb.checked = item.cbChecked;
			tdCb.appendChild(cb);
		}
		tr.appendChild(tdCb);

		const tdNum = document.createElement("td");
		tdNum.className = "md-col-number";
		tdNum.textContent = item.numText;
		if (item.addendum) {
			const s = document.createElement("span");
			s.className = "md-addendum";
			s.textContent = item.addendum;
			tdNum.appendChild(s);
		}
		tr.appendChild(tdNum);

		const tdTitle = document.createElement("td");
		tdTitle.className = "md-col-title";
		tdTitle.textContent = item.title;
		tr.appendChild(tdTitle);

		const tdSource = document.createElement("td");
		tdSource.className = "md-col-source";
		tdSource.textContent = item.sourceText;
		tr.appendChild(tdSource);

		const tdDate = document.createElement("td");
		tdDate.className = "md-col-date";
		tdDate.textContent = item.date;
		tr.appendChild(tdDate);

		tbody.appendChild(tr);
	});
	tableEl.appendChild(tbody);
	wrapper.appendChild(tableEl);

	/* CARDS */
	const cardsEl = document.createElement("div");
	cardsEl.className = "md-contributions-cards";

	items.forEach((item) => {
		const card = document.createElement("div");
		card.className = "md-contrib-card";
		card.dataset.docUrl = item.docUrl;
		card.dataset.docLabel = item.numText + " — " + item.title;

		/* Card header: checkbox + number */
		const cardHeader = document.createElement("div");
		cardHeader.className = "md-card-header";

		if (item.cbValue) {
			const cb = document.createElement("input");
			cb.type = "checkbox";
			cb.className = "md-doc-checkbox";
			cb.value = item.cbValue;
			if (item.cbName) cb.name = item.cbName;
			cb.checked = item.cbChecked;
			cardHeader.appendChild(cb);
		}

		const numEl = document.createElement("div");
		numEl.className = "md-card-number";
		numEl.textContent = item.numText;
		if (item.addendum) {
			const s = document.createElement("span");
			s.className = "md-card-addendum";
			s.textContent = " " + item.addendum;
			numEl.appendChild(s);
		}
		cardHeader.appendChild(numEl);
		card.appendChild(cardHeader);

		/* Card body: labeled fields */
		const cardBody = document.createElement("div");
		cardBody.className = "md-card-body";

		const titleLabel = document.createElement("div");
		titleLabel.className = "md-card-field-label";
		titleLabel.textContent = "Title";
		cardBody.appendChild(titleLabel);
		const titleVal = document.createElement("div");
		titleVal.className = "md-card-field-value";
		titleVal.textContent = item.title;
		cardBody.appendChild(titleVal);

		if (item.sourceText) {
			const srcLabel = document.createElement("div");
			srcLabel.className = "md-card-field-label";
			srcLabel.textContent = "Source";
			cardBody.appendChild(srcLabel);
			const srcVal = document.createElement("div");
			srcVal.className = "md-card-field-value";
			srcVal.textContent = item.sourceText;
			cardBody.appendChild(srcVal);
		}

		card.appendChild(cardBody);

		/* Card footer: date */
		const metaEl = document.createElement("div");
		metaEl.className = "md-card-meta";
		const dateSpan = document.createElement("span");
		dateSpan.textContent = item.date;
		metaEl.appendChild(dateSpan);
		card.appendChild(metaEl);

		cardsEl.appendChild(card);
	});
	wrapper.appendChild(cardsEl);

	/* Set initial view */
	tableEl.style.display = currentView === "table" ? "" : "none";
	cardsEl.style.display = currentView === "cards" ? "grid" : "none";

	/* Preserved sections */
	if (preservedSections && preservedSections.childNodes.length > 0) {
		wrapper.appendChild(preservedSections);

		/* Force ituBtn class on all buttons and strip inline styles + onclick */
		preservedSections.querySelectorAll('input[type="button"], input[type="submit"], button').forEach((btn) => {
			btn.removeAttribute("style");
			btn.removeAttribute("onclick");

			/* Clone to kill all old handlers */
			const fresh = btn.cloneNode(true);
			btn.parentNode.replaceChild(fresh, btn);

			fresh.classList.add("ituBtn");

			/* Tag buttons with action classes for delegation */
			const label = (fresh.value || fresh.textContent || "").trim().toLowerCase();
			if (label.includes("check all") && !label.includes("uncheck")) {
				fresh.classList.add("md-action-check-all");
			} else if (label.includes("uncheck")) {
				fresh.classList.add("md-action-uncheck-all");
			} else if (label.includes("zip")) {
				fresh.classList.add("md-action-zip");
			}
		});
		/* Strip inline bgcolor on cells → let CSS handle it */
		preservedSections.querySelectorAll("[bgcolor]").forEach((el) => {
			el.removeAttribute("bgcolor");
			el.removeAttribute("style");
		});
	}

	container.appendChild(wrapper);
	log("buildContributionsView DONE, items:", items.length);
}

/* ===========================================================
   Navigate to document detail
   =========================================================== */
function navigateToDocument(container, listUrl, docUrl, docLabel) {
	log("navigateToDocument:", docUrl);

	container.innerHTML = "";
	const loading = document.createElement("div");
	loading.className = "md-loading";
	loading.textContent = "Loading document…";
	container.appendChild(loading);

	fetch(docUrl)
		.then((res) => res.arrayBuffer())
		.then((buffer) => {
			let html = new TextDecoder("utf-8").decode(buffer);
			if (html.includes("\ufffd")) {
				try { html = new TextDecoder("iso-8859-1").decode(buffer); } catch {}
			}

			const parser = new DOMParser();
			const doc = parser.parseFromString(html, "text/html");

			const base = new URL(docUrl);
			doc.querySelectorAll("a[href]").forEach((a) => {
				const href = a.getAttribute("href");
				if (href && !href.startsWith("http") && !href.startsWith("#") &&
					!href.startsWith("mailto:") && !href.startsWith("javascript")) {
					try { a.setAttribute("href", new URL(href, base).href); } catch {}
				}
			});

			container.innerHTML = "";
			renderDocumentCards(container, listUrl, docLabel, doc);
		})
		.catch((err) => {
			log("Fetch error:", err);
			container.innerHTML = `<p style="color:red">❌ Failed to load: ${err.message}</p>`;
		});
}

/* ===========================================================
   Extract document metadata from fetched page
   =========================================================== */
function extractDocMeta(docRoot) {
	const metaData = [];
	const fields = ["Document", "Title", "Date", "Source", "Access"];

	/* Strategy 1: <b> or <strong> tags */
	docRoot.querySelectorAll("b, strong").forEach((bold) => {
		const rawLabel = bold.textContent.replace(/\s+/g, " ").trim().replace(/\s*:?\s*$/, "").trim();
		const matchedField = fields.find(f => rawLabel.toLowerCase() === f.toLowerCase());
		if (!matchedField) return;

		let value = "";
		let valueHtml = "";
		let sibling = bold.nextSibling;
		while (sibling) {
			if (sibling.nodeType === 3) {
				const txt = sibling.textContent.replace(/^[\s:]+/, "");
				value += txt;
				valueHtml += txt;
			} else if (sibling.nodeType === 1) {
				const tag = sibling.tagName;
				if (tag === "B" || tag === "STRONG" || tag === "HR") break;
				if (tag === "BR") {
					const next = sibling.nextSibling;
					if (next && next.nodeType === 1 && (next.tagName === "B" || next.tagName === "STRONG")) break;
					value += " ";
					valueHtml += " ";
				} else {
					value += sibling.textContent;
					valueHtml += sibling.outerHTML;
				}
			}
			sibling = sibling.nextSibling;
		}

		value = value.replace(/\s+/g, " ").trim();
		if (value && !metaData.some(m => m.label === matchedField)) {
			metaData.push({ label: matchedField, value, html: valueHtml.trim() });
		}
	});

	/* Strategy 2: look in <td> pairs (label cell + value cell) */
	if (metaData.length === 0) {
		docRoot.querySelectorAll("tr").forEach((tr) => {
			const cells = tr.querySelectorAll("td, th");
			if (cells.length >= 2) {
				const label = cells[0].textContent.replace(/\s+/g, " ").trim().replace(/\s*:?\s*$/, "").trim();
				const matchedField = fields.find(f => label.toLowerCase() === f.toLowerCase());
				if (matchedField && !metaData.some(m => m.label === matchedField)) {
					metaData.push({
						label: matchedField,
						value: cells[1].textContent.replace(/\s+/g, " ").trim(),
						html: cells[1].innerHTML.trim()
					});
				}
			}
		});
	}

	return metaData;
}

/* ===========================================================
   Build metadata DOM + force links to open in new tab
   =========================================================== */
function buildMetaElement(metaData) {
	if (!metaData || !metaData.length) return null;

	const metaEl = document.createElement("div");
	metaEl.className = "md-doc-meta";

	metaData.forEach(({ label, value, html }) => {
		const row = document.createElement("div");
		row.className = "md-meta-row";

		const labelEl = document.createElement("div");
		labelEl.className = "md-meta-label";
		labelEl.textContent = label;
		row.appendChild(labelEl);

		const valueEl = document.createElement("div");
		valueEl.className = "md-meta-value";
		if (label === "Access" && html) {
			valueEl.innerHTML = html;
		} else {
			valueEl.textContent = value;
		}
		row.appendChild(valueEl);
		metaEl.appendChild(row);
	});

	/* Force ALL links inside metadata to open in new tab */
	metaEl.querySelectorAll("a[href]").forEach((a) => {
		a.setAttribute("target", "_blank");
		a.setAttribute("rel", "noopener noreferrer");
	});

	return metaEl;
}

/* ===========================================================
   Type 2: Document language/format cards
   =========================================================== */
function renderDocumentCards(container, listUrl, docLabel, sourceDoc) {
	const searchRoot = sourceDoc || container;

	const pdfIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="#c0392b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><text x="7" y="17" fill="#c0392b" stroke="none" font-size="6" font-weight="700" font-family="system-ui">PDF</text></svg>`;
	const wordIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="#2980b9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><text x="7" y="17" fill="#2980b9" stroke="none" font-size="5" font-weight="700" font-family="system-ui">DOC</text></svg>`;

	const langNames = { E: "English", F: "Français", S: "Español", A: "Arabic", C: "Chinese", R: "Russian" };

	const allLinks = Array.from(searchRoot.querySelectorAll("a[href]")).filter((a) => {
		const h = (a.getAttribute("href") || "").toUpperCase();
		return h.includes("PDF-") || h.includes("MSW-");
	});

	log("renderDocumentCards, links found:", allLinks.length);

	const langMap = new Map();

	allLinks.forEach((a) => {
		const href = a.getAttribute("href") || "";
		const hrefUpper = href.toUpperCase();
		const urlLangMatch = href.match(/[-](E|F|S|A|C|R)\./i);
		if (!urlLangMatch) return;

		const langCode = urlLangMatch[1].toUpperCase();
		const lang = langNames[langCode] || langCode;
		const isPdf = hrefUpper.includes("PDF-");
		const isWord = hrefUpper.includes("MSW-");
		if (!isPdf && !isWord) return;

		if (!langMap.has(lang)) langMap.set(lang, { pdf: "", word: "", date: "" });
		const entry = langMap.get(lang);

		if (isPdf && !entry.pdf) entry.pdf = href;
		if (isWord && !entry.word) entry.word = href;

		if (!entry.date) {
			const parentRow = a.closest("tr");
			if (parentRow) {
				parentRow.querySelectorAll("td").forEach((td) => {
					const txt = td.textContent.trim();
					if (/^\d{4}-\d{2}-\d{2}$/.test(txt)) entry.date = txt;
				});
			}
		}
	});

	const wrapper = document.createElement("div");

	/* Breadcrumb (only when navigated from a list) */
	if (listUrl) {
		const bc = document.createElement("nav");
		bc.className = "md-breadcrumb";

		let docNum = "";
		let docTitle = "";
		if (docLabel) {
			const match = docLabel.match(/^(\[.*?\])\s*[—–-]\s*(.*)/);
			if (match) {
				docNum = match[1].trim();
				docTitle = match[2].trim();
			} else {
				docTitle = docLabel;
			}
		}

		bc.innerHTML = `<a class="md-bc-back"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>Documents</a>`
			+ (docLabel ? `<span class="md-bc-sep">/</span>` : "")
			+ (docNum ? `<span class="md-bc-doc-num">${docNum}</span>` : "")
			+ (docTitle ? `<span class="md-bc-title" title="${docTitle.replace(/"/g, '&quot;')}">${docTitle}</span>` : "");

		wrapper.appendChild(bc);
	}

	/* ✅ Extract metadata — ALWAYS, whether sourceDoc or container (Type 2 direct) */
	const metaData = extractDocMeta(searchRoot);
	log("Doc metadata extracted:", metaData.length, metaData.map(m => m.label));
	const metaEl = buildMetaElement(metaData);

	if (langMap.size === 0) {
		const msg = document.createElement("p");
		msg.style.cssText = "color:#666;font-style:italic;padding:1rem 0;";
		msg.textContent = "No downloadable documents found.";
		wrapper.appendChild(msg);
		if (metaEl) wrapper.appendChild(metaEl);
		container.innerHTML = "";
		container.appendChild(wrapper);
		return;
	}

	const cards = document.createElement("div");
	cards.className = "md-doc-cards";

	const langOrder = ["English", "Français", "Español", "Arabic", "Chinese", "Russian"];
	Array.from(langMap.entries())
		.sort(([a], [b]) => {
			const ia = langOrder.indexOf(a);
			const ib = langOrder.indexOf(b);
			return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
		})
		.forEach(([lang, data]) => {
			const row = document.createElement("div");
			row.className = "md-doc-row";

			const langEl = document.createElement("div");
			langEl.className = "md-doc-lang";
			langEl.textContent = lang;
			row.appendChild(langEl);

			const linksEl = document.createElement("div");
			linksEl.className = "md-doc-links";
			if (data.pdf) {
				const a = document.createElement("a");
				a.className = "md-doc-link"; a.href = data.pdf;
				a.target = "_blank"; a.rel = "noopener noreferrer";
				a.innerHTML = `${pdfIcon} PDF (Acrobat)`;
				linksEl.appendChild(a);
			}
			if (data.word) {
				const a = document.createElement("a");
				a.className = "md-doc-link"; a.href = data.word;
				a.target = "_blank"; a.rel = "noopener noreferrer";
				a.innerHTML = `${wordIcon} Word`;
				linksEl.appendChild(a);
			}
			row.appendChild(linksEl);

			const dateEl = document.createElement("div");
			dateEl.className = "md-doc-date";
			dateEl.textContent = data.date || "";
			row.appendChild(dateEl);

			cards.appendChild(row);
		});

	wrapper.appendChild(cards);

	/* Metadata below downloads */
	if (metaEl) {
		wrapper.appendChild(metaEl);
	}

	container.innerHTML = "";
	container.appendChild(wrapper);
}

/* ===========================================================
   Reload list
   =========================================================== */
function reloadList(container, listUrl) {
	container.innerHTML = "";
	const loading = document.createElement("div");
	loading.className = "md-loading";
	loading.textContent = "Loading documents…";
	container.appendChild(loading);

	fetch(listUrl)
		.then((res) => res.arrayBuffer())
		.then((buffer) => {
			let html = new TextDecoder("utf-8").decode(buffer);
			if (html.includes("\ufffd")) {
				try { html = new TextDecoder("iso-8859-1").decode(buffer); } catch {}
			}
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, "text/html");
			const selector = container.getAttribute("data-selector") || "form";
			const target = doc.querySelector(selector);
			if (!target) { container.innerHTML = `<p style="color:red">⚠️ Could not reload list.</p>`; return; }

			const base = new URL(listUrl);
			target.querySelectorAll("a[href]").forEach((a) => {
				const href = a.getAttribute("href");
				if (href && !href.startsWith("http") && !href.startsWith("#") && !href.startsWith("mailto:")) {
					try { a.setAttribute("href", new URL(href, base).href); } catch {}
				}
			});

			container.innerHTML = "";
			container.appendChild(target.cloneNode(true));
			postProcessMdPage(container);
		})
		.catch((err) => {
			container.innerHTML = `<p style="color:red">❌ Failed to reload: ${err.message}</p>`;
		});
}

/* ===========================================================
   Hub Article Cards — parse and render /hub/ search results
   as image cards with pagination.
   =========================================================== */

function hubFindImage(el) {
	const img = el.querySelector("img");
	if (img) {
		const src = img.getAttribute("data-src") || img.getAttribute("data-lazy-src") || img.getAttribute("src") || "";
		if (src && !src.startsWith("data:")) return src;
	}
	const source = el.querySelector("picture source[srcset]");
	if (source) {
		const first = (source.getAttribute("srcset") || "").split(",")[0].trim().split(" ")[0];
		if (first && !first.startsWith("data:")) return first;
	}
	const bgEl = el.querySelector("[data-bg]");
	if (bgEl) return (bgEl.getAttribute("data-bg") || "").replace(/^url\(["']?/, "").replace(/["']?\)$/, "");
	return "";
}

function hubFindDate(el) {
	const dateEl = el.querySelector("time, [class*='date'], [datetime]");
	if (dateEl) {
		const dt = dateEl.getAttribute("datetime") || dateEl.textContent.trim();
		if (dt) return dt;
	}
	const m = el.textContent.match(/\d{1,2}\s+(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\w*\s+\d{4}/i);
	return m ? m[0] : "";
}

function parseHubArticles(container) {
	const articles = [];

	/* Strategy A: <article> or card-like containers */
	const articleEls = container.querySelectorAll(
		'article, [class*="post-card"], [class*="search-result"], [class*="card-linked"]'
	);

	if (articleEls.length >= 2) {
		articleEls.forEach((el) => {
			const titleEl = el.querySelector("h2 a, h3 a, .entry-title a, [class*='title'] a");
			if (!titleEl) return;
			const href = titleEl.getAttribute("href") || "";
			if (!href.includes("/hub/")) return;

			const catEl = el.querySelector('[class*="category"], [class*="tag"], a[href*="post_type"]');
			articles.push({
				title: titleEl.textContent.trim(),
				url: href,
				imgSrc: hubFindImage(el),
				category: catEl ? catEl.textContent.trim() : "News",
				date: hubFindDate(el),
			});
		});
	}

	/* Strategy B: fallback — scan h2/h3 links to /hub/ */
	if (articles.length < 2) {
		articles.length = 0;
		const headings = container.querySelectorAll("h2 a[href*='/hub/'], h3 a[href*='/hub/']");

		headings.forEach((a) => {
			const href = a.getAttribute("href") || "";
			if (!/\/hub\/\d{4}\/|\/hub\/pubs\/|\/hub\/events\/|\/hub\/news\//.test(href) &&
				!/\/hub\/[a-z]/.test(href)) return;
			if (a.closest("nav, header, footer, .site-header, .site-footer")) return;

			const title = a.textContent.trim();
			if (!title || title.length < 5) return;

			let parent = a.closest("h2, h3")?.parentElement;
			if (!parent) parent = a.parentElement?.parentElement;

			let imgSrc = parent ? hubFindImage(parent) : "";
			let category = "";
			let date = "";
			if (parent) {
				const catLink = parent.querySelector('a[href*="post_type"], [class*="category"]');
				if (catLink) category = catLink.textContent.trim();
				date = hubFindDate(parent);
			}

			/* Also check previous sibling for image (hub layout: image div then text div) */
			if (!imgSrc && parent && parent.previousElementSibling) {
				imgSrc = hubFindImage(parent.previousElementSibling);
			}

			if (articles.some((x) => x.url === href)) return;
			articles.push({ title, url: href, imgSrc, category: category || "News", date });
		});
	}

	return articles;
}

function hubPlaceholderEl() {
	const ph = document.createElement("div");
	ph.className = "hub-card-img-placeholder";
	ph.innerHTML = '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>';
	return ph;
}

function renderHubCards(articles, pagEl, totalCount) {
	const wrapper = document.createElement("div");
	wrapper.className = "hub-cards-wrapper";

	const header = document.createElement("div");
	header.className = "hub-cards-header";
	const count = totalCount || articles.length;
	header.innerHTML = `<span class="hub-cards-count"><strong>${count}</strong> result${count > 1 ? "s" : ""}</span>`;
	wrapper.appendChild(header);

	const grid = document.createElement("div");
	grid.className = "hub-cards-grid";

	articles.forEach((article) => {
		const card = document.createElement("a");
		card.className = "hub-card";
		card.href = article.url;
		card.target = "_blank";
		card.rel = "noopener noreferrer";

		if (article.imgSrc) {
			const img = document.createElement("img");
			img.className = "hub-card-img";
			img.src = article.imgSrc;
			img.alt = article.title;
			img.loading = "lazy";
			img.decoding = "async";
			img.onerror = function () { this.replaceWith(hubPlaceholderEl()); };
			card.appendChild(img);
		} else {
			card.appendChild(hubPlaceholderEl());
		}

		const body = document.createElement("div");
		body.className = "hub-card-body";

		if (article.category) {
			const tag = document.createElement("span");
			tag.className = "hub-card-tag";
			tag.textContent = article.category;
			body.appendChild(tag);
		}

		const titleEl = document.createElement("div");
		titleEl.className = "hub-card-title";
		titleEl.textContent = article.title;
		body.appendChild(titleEl);

		if (article.date) {
			const dateEl = document.createElement("div");
			dateEl.className = "hub-card-date";
			dateEl.textContent = article.date;
			body.appendChild(dateEl);
		}

		card.appendChild(body);
		grid.appendChild(card);
	});

	wrapper.appendChild(grid);

	/* Pagination — clone existing and restyle for AJAX handler compatibility */
	if (pagEl) {
		const pagClone = pagEl.cloneNode(true);
		pagClone.classList.add("hub-cards-pagination", "pagination");
		/* Ensure page-numbers class on all links for AJAX handler */
		pagClone.querySelectorAll("a").forEach((a) => {
			if (!a.classList.contains("page-numbers")) a.classList.add("page-numbers");
		});
		wrapper.appendChild(pagClone);
	}

	return wrapper;
}

export function postProcessHubArticles(container) {
	if (!container) return false;
	const sourceUrl = (container.getAttribute("data-url") || "");
	if (!sourceUrl.includes("/hub/")) return false;
	if (container.querySelector(".hub-cards-wrapper")) return true;

	injectMdStyles();

	/* Remove "limited functionality" warning */
	container.querySelectorAll("div, p, span").forEach((el) => {
		if (el.textContent.includes("limited functionality in this browser")) {
			el.remove();
		}
	});

	const articles = parseHubArticles(container);
	if (articles.length < 1) return false;

	log("Hub articles found:", articles.length);

	/* Find pagination */
	const pagEl = container.querySelector('nav.pagination, .pagination, nav.nav-links, .nav-links') ||
		(container.querySelectorAll("a.page-numbers").length >= 2
			? container.querySelectorAll("a.page-numbers")[0].parentElement
			: null);

	/* Try to extract total result count */
	let totalCount = 0;
	const countEl = container.querySelector("strong, b");
	if (countEl) {
		const n = parseInt(countEl.textContent.trim(), 10);
		if (n > 0 && n < 10000) totalCount = n;
	}

	const cardUI = renderHubCards(articles, pagEl, totalCount);
	container.innerHTML = "";
	container.appendChild(cardUI);
	return true;
}

/* ===========================================================
   Main entry: initExtractedTableCards
   =========================================================== */
export function initExtractedTableCards(container) {
	if (!container)
		container = document.getElementById("extracted-content-placeholder");
	if (!container) return;

	if (container.dataset.tcInit === "1") {
		log("initExtractedTableCards SKIP — already initialized");
		return;
	}
	container.dataset.tcInit = "1";

	const sourceUrl = container.getAttribute("data-url") || "";
	if (sourceUrl.includes("itu.int/md/")) {
		postProcessMdPage(container);
		return;
	}

	// Hub article cards (search results, news listings, etc.)
	if (sourceUrl.includes("/hub/")) {
		if (postProcessHubArticles(container)) return;
		// fallthrough to table detection if no articles found
	}

	const tables = container.querySelectorAll("table");
	if (!tables.length) return;

	tables.forEach((table) => {
		if (table.dataset.extInit === "1") return;
		table.dataset.extInit = "1";

		const headerRow = table.querySelector("tr.ms-viewheadertr, thead tr, tr:first-child");
		if (!headerRow) return;
		headerRow.classList.add("ext-header-row");

		const headers = Array.from(headerRow.querySelectorAll("th, td")).map((c) => c.textContent.trim());
		if (!headers.length) return;

		const bodyRows = Array.from(table.querySelectorAll("tr")).filter((r) => r !== headerRow);

		bodyRows.forEach((row) => {
			row.querySelectorAll("td").forEach((cell, i) => {
				if (headers[i]) cell.setAttribute("data-label", headers[i]);
			});
			row._searchText = row.textContent.toLowerCase();
			row.style.removeProperty("display");
		});

		const highlightGuard = new MutationObserver((mutations) => {
			let dirty = false;
			for (const m of mutations) {
				for (const node of m.addedNodes) {
					if (node.nodeType === 1 && node.tagName === "SPAN" && node.classList.contains("highlight")) {
						node.replaceWith(document.createTextNode(node.textContent));
						dirty = true;
					}
				}
			}
			if (dirty) table.querySelectorAll("td").forEach((td) => td.normalize());
		});
		highlightGuard.observe(table, { childList: true, subtree: true });

		const pag = document.createElement("div");
		pag.className = "ext-table-pagination";
		table.parentNode.insertBefore(pag, table.nextSibling);

		const isMobile = window.innerWidth <= 768;
		let currentPage = 0;
		table.setAttribute("data-ext-view", isMobile ? "cards" : "table");

		function refresh() {
			const isCards = table.getAttribute("data-ext-view") === "cards";
			const filtered = bodyRows.filter((r) => {
				if (r.classList.contains("ext-search-hidden")) return false;
				if (r.style.display === "none" && !r.classList.contains("ext-card-hidden")) return false;
				return true;
			});
			bodyRows.forEach((r) => r.classList.remove("ext-card-hidden"));
			if (isCards && filtered.length > CARDS_PER_PAGE) {
				const totalPages = Math.ceil(filtered.length / CARDS_PER_PAGE);
				if (currentPage >= totalPages) currentPage = totalPages - 1;
				if (currentPage < 0) currentPage = 0;
				const start = currentPage * CARDS_PER_PAGE;
				const end = start + CARDS_PER_PAGE;
				filtered.forEach((r, i) => { if (i < start || i >= end) r.classList.add("ext-card-hidden"); });
				buildPagination(totalPages);
				pag.style.display = "flex";
			} else { pag.innerHTML = ""; pag.style.display = "none"; }
		}

		function applySearch(query) {
			const term = (query || "").trim().toLowerCase();
			bodyRows.forEach((row) => {
				if (!term || term.length < 2) row.classList.remove("ext-search-hidden");
				else row.classList.toggle("ext-search-hidden", !row._searchText.includes(term));
			});
			currentPage = 0; refresh();
		}

		const searchInput = document.getElementById("searchInput");
		if (searchInput) searchInput.addEventListener("input", () => { applySearch(searchInput.value); setTimeout(() => refresh(), 50); });
		const clearBtn = document.getElementById("clearSearch");
		if (clearBtn) clearBtn.addEventListener("click", () => { setTimeout(() => { applySearch(""); refresh(); }, 50); });

		function buildPagination(totalPages) {
			pag.innerHTML = "";
			appendBtn("‹", currentPage === 0, "ext-page-prev", () => { if (currentPage > 0) { currentPage--; refresh(); scrollUp(); } });
			pageRange(currentPage, totalPages).forEach((item) => {
				if (item === "…") { const s = document.createElement("span"); s.className = "ext-page-dots"; s.textContent = "…"; pag.appendChild(s); }
				else appendBtn(item + 1, false, item === currentPage ? "is-active" : "", () => { currentPage = item; refresh(); scrollUp(); });
			});
			appendBtn("›", currentPage >= totalPages - 1, "ext-page-next", () => { if (currentPage < totalPages - 1) { currentPage++; refresh(); scrollUp(); } });
		}

		function appendBtn(text, disabled, extraClass, onClick) {
			const b = document.createElement("button"); b.type = "button"; b.className = "ext-page-btn " + (extraClass || "");
			b.textContent = text; b.disabled = !!disabled; b.addEventListener("click", onClick); pag.appendChild(b);
		}

		function pageRange(cur, total) {
			if (total <= 7) return Array.from({ length: total }, (_, i) => i);
			const p = [0]; if (cur > 2) p.push("…");
			for (let i = Math.max(1, cur - 1); i <= Math.min(total - 2, cur + 1); i++) p.push(i);
			if (cur < total - 3) p.push("…"); p.push(total - 1); return p;
		}

		function scrollUp() { (container || table).scrollIntoView({ behavior: "smooth", block: "start" }); }

		if (!isMobile) {
			const toolbar = document.createElement("div");
			toolbar.className = "ext-table-toolbar";
			toolbar.innerHTML = `<div class="ext-table-controls">
				<button class="ext-table-switch-btn is-active" data-view="table" type="button"><svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor"><path d="M18 3H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM2 8h5v4H2V8zm7 0h9v4H9V8zM2 5h16v1H2V5zm0 9h5v1H2v-1zm7 0h9v1H9v-1z"/></svg> Table</button>
				<button class="ext-table-switch-btn" data-view="cards" type="button"><svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor"><path d="M2 2h4v4H2V2zm6 0h4v4H8V2zm6 0h4v4h-4V2zM2 8h4v4H2V8zm6 0h4v4H8V8zm6 0h4v4h-4V8zM2 14h4v4H2v-4zm6 0h4v4H8v-4zm6 0h4v4h-4v-4z"/></svg> Cards</button>
			</div>`;
			table.parentNode.insertBefore(toolbar, table);
			toolbar.addEventListener("click", (e) => {
				const btn = e.target.closest(".ext-table-switch-btn"); if (!btn) return;
				currentPage = 0; table.setAttribute("data-ext-view", btn.dataset.view);
				toolbar.querySelectorAll(".ext-table-switch-btn").forEach((b) => b.classList.remove("is-active"));
				btn.classList.add("is-active"); refresh();
			});
		}

		refresh();
	});
}